export default "__VITE_ASSET__DBrg7R65__"